import { IMAGE_BASE_PATH } from "@/config/config";
import cns from "classnames";
import Image from "next/image";
import { func } from "prop-types";

import styles from "./header.module.scss";

export default function Logo({ handleLogoClick }) {
  return (
    <div
      className={cns(styles.logo, "cursor-pointer")}
      onClick={handleLogoClick}
    >
      <img src={`${IMAGE_BASE_PATH}/logo.png`} alt={"Logo"} />{" "}
      {/* <Image
      //   alt="Tata AIG Logo"
      //   src={`${IMAGE_BASE_PATH}/logo.png`}
      //   // src={`${IMAGE_BASE_PATH}/images/angle-down.svg`}
      //   width={60}
      //   height={60}
      //   style={styles.logo}
      //   priority
      // /> */}
    </div>
  );
}

Logo.propTypes = {
  handleLogoClick: func.isRequired,
};
